import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from 'react-router-dom';

//Router
import {
    Route,
    Switch
} from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions";

//Controllers

import { headerSearch, tabs, unoTheme } from '../../../assets/styles/unoTheme';

import LaunchIcon from '@material-ui/icons/Launch';
import PrintIcon from '@material-ui/icons/Print';
import UpdateIcon from '@material-ui/icons/Update';
import { ClientRiskDataAPI } from "../../../API/client_risk_data";
import { ClientRiskDataController } from "../../../controllers/ClientRiskDataController";
import { RiskController } from "../../../controllers/RiskController";
import { MyTab, MyTabs } from "../../utils/MyTabs";
import { reportTypes } from "../../utils/ReportTypes";
import { path } from "../../utils/routesPaths";
import UnoButton from "../../utils/UnoButton";
import { checkUserIsRole, roles } from "../../utils/user";
import { getFirstAndEndDateByMonthAndYear, getFirstBeforeBusinessDay, getLastPtDayMonth, getMonthName } from "../../utils/utils";
import RiskArticlesScreen from "./RiskTabs/RiskArticlesScreen";
import RiskBenchmarksScreen from "./RiskTabs/RiskBenchmarksScreen";
import RiskMarketScreen from "./RiskTabs/RiskMarketScreen";
import RiskPolicyScreen from "./RiskTabs/RiskPolicyScreen";
import { LegislationArticleAPI } from '../../../API/legislation_article';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    green: {
        color: 'green'
    },
    red: {
        color: 'red',
    },
    headerSearch: headerSearch,
    inputSearch: {
        width: "300px",
        background: "white"
    },
    toStickyHeader: {
        display: 'flex',
        height: '100%',
    },
    tabs: tabs,
    shortWidthTab: {
        '& .MuiTab-root': {
            minWidth: '100px !important',
        }
    },
    bottomTabs: {
        height: '24px',
        width: '100%',
        background: unoTheme.menuContent,
    },
    tabsWithRight: {
        display: 'flex',
        flexDirection: 'row',
        paddingRight: '16px',
        alignItems: 'center',

        '& .MuiToggleButtonGroup-root': {
            alignItems: 'center',

            '& .MuiToggleButton-label': {
                whiteSpace: 'nowrap'
            }
        }
    },

    flexCenterDiv: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    rightHeader: {
        gap: "8px",
        display: 'flex',
        alignItems: 'center',
    },
});

export default function RiskScreen() {

    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const riskMarketRef = useRef();

    const clientOn = useSelector(state => state.clientOn)
    const currentUser = useSelector(state => state.currentUser)
    const [tabValue, setTabValue] = useState(null);

    const [ableToRisk, setAbleToRisk] = useState(false);

    const [marketData, setMarketData] = useState();
    const [articlesData, setArticlesData] = useState();
    const [benchmarksData, setBenchmarksData] = useState();
    const [policyData, setPolicyData] = useState();

    const [resolution, setResolution] = useState();

    const [clientOnScreen, setClientOnScreen] = useState(undefined);

    const [flagDoExcelRiskMarket, setFlagDoExcelRiskMarket] = React.useState(false);
    const [flagDoExcelRiskArticles, setFlagDoExcelRiskArticles] = React.useState(false);
    const [flagDoExcelRiskBenchmarks, setFlagDoExcelRiskBenchmarks] = React.useState(false);
    const [flagDoExcelRiskPolicy, setFlagDoExcelRiskPolicy] = React.useState(false);

    function resetFlag() {
        setFlagDoExcelRiskMarket(false);
        setFlagDoExcelRiskArticles(false);
        setFlagDoExcelRiskBenchmarks(false);
        setFlagDoExcelRiskPolicy(false);
    }

    const innerLoad = useSelector(state => state.innerLoad)

    const handleChangeTabValue = (event, newValue) => {

        console.log('newValue: ', newValue);
        setTabValue(newValue);

        if (newValue == 0) {
            history.push(path.analysis.risk.market)
        } else if (newValue == 1) {
            history.push(path.analysis.risk.articles)
        } else if (newValue == 2) {
            history.push(path.analysis.risk.benchmarks)
        } else {
            history.push(path.analysis.risk.policy)
        }

    };

    async function verifyAndCreateClientRiskData(clientId, month, year) {
        const {
            able,
            data
        } = await ClientRiskDataController.createData(clientId, month, year);

        const responseResolution = await LegislationArticleAPI.getResolutionVersionIdByDate(getFirstAndEndDateByMonthAndYear(month, year).endDate);
        setResolution(responseResolution.body.rows[0]);

        if (data) {

            const {
                articles_data,
                benchmarks_data,
                market_data,
            } = data;

            if (articles_data && benchmarks_data && market_data) {

                const endDate = getFirstBeforeBusinessDay(getLastPtDayMonth(clientOn.client.selectedPortfolioMonth, clientOn.client.selectedPortfolioYear));

                //As três abas já estão geradas: o servidor só recalcula a política
                const riskData = await RiskController.getRiskData(clientOn.client.id, endDate);

                if (riskData) {
                    setMarketData(riskData.market)
                    setArticlesData(riskData.articles)
                    setBenchmarksData(riskData.benchmarks)
                    setPolicyData(riskData.policy)
                }
            }
        }

        if (able) {
            setAbleToRisk(true);
        }

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: false,
        }));
    }

    async function processFullRisk() {

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Gerando informações de risco...'
        }))

        const endDate = getFirstBeforeBusinessDay(getLastPtDayMonth(clientOn.client.selectedPortfolioMonth, clientOn.client.selectedPortfolioYear));

        //Mercado, Enquadramentos, Benchmarks e Política gerados de uma vez no servidor
        const riskData = await RiskController.getRiskData(clientOn.client.id, endDate);

        if (riskData) {
            setMarketData(riskData.market)
            setArticlesData(riskData.articles)
            setBenchmarksData(riskData.benchmarks)
            setPolicyData(riskData.policy)
        }

        if (!riskData || riskData.errors.length) {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: "Falha ao gerar as informações de risco, tente novamente"
            }))
        }

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: false,
        }));
    }

    const doResetRisk = async (clientId, month, year) => {

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Gerando informações de Mercado... ( 1/4 )'
        }))
        const responseDelete = await ClientRiskDataAPI.deleteDataByMonthAndYear(clientId, month, year)

        if (responseDelete.success) {

            setAbleToRisk(null)
            setMarketData(null)
            setArticlesData(null)
            setBenchmarksData(null)
            setPolicyData(null)
            setTabValue(null)

            load();

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: "Informação de risco resetada com sucesso!"
            }))

        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: "Falha ao deletar informação de risco"
            }))
        }

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: false,
        }));
    }

    function doReport() {

        dispatch(allActions.reportLoadActions.setReportLoad({
            show: true,
            reportType: reportTypes.risk.cod,
            periodReport: 'mensal',
            message: 'Gerando o relatório de Risco...'
        }))

    }

    function load() {

        if (clientOn
            && clientOn.client
            && clientOn.client.id
            && clientOn.client.selectedPortfolioMonth
            && clientOn.client.selectedPortfolioYear) {

            dispatch(allActions.innerLoadActions.setInnerLoad({
                show: true,
                loadMessage: 'Carregando...',
            }));
            verifyAndCreateClientRiskData(clientOn.client.id, clientOn.client.selectedPortfolioMonth, clientOn.client.selectedPortfolioYear);
        }
    }

    useEffect(() => {

        //Caso em que alterou-se o cliente
        if (clientOn && clientOn.client
            && (!clientOnScreen || clientOn.client.id != clientOnScreen.id)) {

            setAbleToRisk(null)
            setMarketData(null)
            setArticlesData(null)
            setBenchmarksData(null)
            setPolicyData(null)
            setTabValue(null)

            load();

            //Caso em que alterou-se o mês ou o ano no controller no dashboard
        } else if (clientOn && clientOn.client && clientOnScreen
            && clientOn.client.id == clientOnScreen.id
            && clientOn.client.selectedPortfolioMonth && clientOn.client.selectedPortfolioYear
            && clientOn.client.portfolio_closed != clientOnScreen.portfolio_closed) {

            setAbleToRisk(null)
            setMarketData(null)
            setArticlesData(null)
            setBenchmarksData(null)
            setPolicyData(null)
            setTabValue(null)

            load();
        }


    }, [clientOn])

    const isReadyToUse = marketData && articlesData && benchmarksData && policyData;

    //Enquadramentos liberados apenas para uso interno enquanto a adequação
    //à resolução 5.272 está em validação
    const ableToArticles = checkUserIsRole(currentUser, [roles.admin, roles.superadmin, roles.advisor]);

    useEffect(() => {
        if (marketData && articlesData && benchmarksData && policyData && tabValue == null) {
            handleChangeTabValue(null, 0)
        }
    }, [marketData, articlesData, benchmarksData, policyData])

    return (
        <div className={classes.root}>

            <div className={classes.tabsWithRight}>

                <div className={[classes.tabs, classes.shortWidthTab].join(' ')}>

                    <MyTabs
                        value={tabValue}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleChangeTabValue}>

                        <MyTab label="MERCADO" disabled={!isReadyToUse} />
                        <MyTab label="ENQUADRAMENTOS" disabled={!isReadyToUse || !ableToArticles} />
                        <MyTab label="BENCHMARKS" disabled={!isReadyToUse} />
                        <MyTab label="POLÍTICA DE INVESTIMENTOS" disabled={!isReadyToUse} />

                    </MyTabs>

                </div>

                <div className={classes.rightHeader}>
                    {/* <UnoButton
                        size={'small'}
                        onClick={() => riskMarketRef && riskMarketRef.current ? riskMarketRef.current.excelValidation() : null}
                        type='success'
                        startIcon={<PrintIcon />}>
                        {"Tabela validação"}
                    </UnoButton> */}

                    {isReadyToUse && tabValue === 0 ? (
                        <UnoButton
                            size={'small'}
                            onClick={() => setFlagDoExcelRiskMarket(true)}
                            type='success'
                            startIcon={<PrintIcon />}>
                            {"Excel"}
                        </UnoButton>
                    ) : null}

                    {isReadyToUse && tabValue === 1 ? (
                        <UnoButton
                            size={'small'}
                            onClick={() => setFlagDoExcelRiskArticles(true)}
                            type='success'
                            startIcon={<PrintIcon />}>
                            {"Excel"}
                        </UnoButton>
                    ) : null}

                    {isReadyToUse && tabValue === 2 ? (
                        <UnoButton
                            size={'small'}
                            onClick={() => setFlagDoExcelRiskBenchmarks(true)}
                            type='success'
                            startIcon={<PrintIcon />}>
                            {"Excel"}
                        </UnoButton>
                    ) : null}

                    {isReadyToUse && tabValue === 3 ? (
                        <UnoButton
                            size={'small'}
                            onClick={() => setFlagDoExcelRiskPolicy(true)}
                            type='success'
                            startIcon={<PrintIcon />}>
                            {"Excel"}
                        </UnoButton>
                    ) : null}

                    {
                        isReadyToUse && ableToArticles ?
                            <UnoButton
                                size={'small'}
                                type='warning'
                                onClick={() => doResetRisk(clientOn.client.id, clientOn.client.selectedPortfolioMonth, clientOn.client.selectedPortfolioYear)}
                                startIcon={<UpdateIcon />}>
                                {"Resetar risco"}
                            </UnoButton> : null
                    }

                    {
                        isReadyToUse ?
                            <UnoButton
                                size={'small'}
                                type='primary'
                                onClick={() => doReport()}
                                startIcon={<PrintIcon />}>
                                {"Gerar Relatório de Risco"}
                            </UnoButton> : null
                    }





                </div>
            </div>

            {
                ableToRisk ?

                    <>
                        {

                            isReadyToUse ?
                                <Switch className={classes.switch}>
                                    <Route path={path.analysis.risk.market}>
                                        <RiskMarketScreen
                                            ref={riskMarketRef}
                                            data={marketData}
                                            resolutionName={resolution?.resolution_name ?? "-"}
                                            flagDoExcelRiskMarket={flagDoExcelRiskMarket}
                                            resetFlag={() => setFlagDoExcelRiskMarket(false)}
                                        />
                                    </Route>
                                    <Route path={path.analysis.risk.articles}>
                                        {
                                            ableToArticles ?
                                                <RiskArticlesScreen
                                                    data={articlesData}
                                                    flagDoExcelRiskArticles={flagDoExcelRiskArticles}
                                                    resetFlag={() => setFlagDoExcelRiskArticles(false)}
                                                /> : null
                                        }
                                    </Route>
                                    <Route path={path.analysis.risk.benchmarks}>
                                        <RiskBenchmarksScreen
                                            data={benchmarksData}
                                            flagDoExcelRiskBenchmarks={flagDoExcelRiskBenchmarks}
                                            resetFlag={() => setFlagDoExcelRiskBenchmarks(false)}
                                        />
                                    </Route>
                                    <Route path={path.analysis.risk.policy}>
                                        <RiskPolicyScreen
                                            data={policyData}
                                            resolutionName={resolution?.resolution_name ?? "-"}
                                            flagDoExcelRiskPolicy={flagDoExcelRiskPolicy}
                                            resetFlag={() => setFlagDoExcelRiskPolicy(false)}
                                        />
                                    </Route>
                                </Switch>

                                : null
                        }

                        {
                            clientOn?.client?.selectedPortfolioMonth
                                && clientOn.client.selectedPortfolioYear
                                && !isReadyToUse
                                && !innerLoad?.show ?

                                <div class={'defaultScrollWithHeaderContent'}>

                                    <div className={classes.flexCenterDiv}>

                                        <UnoButton
                                            size={'small'}
                                            type='primary'
                                            onClick={() => processFullRisk()}
                                            startIcon={<LaunchIcon />}>
                                            {`Gerar as Informações de risco [ ${getMonthName(clientOn.client.selectedPortfolioMonth)}/${clientOn.client.selectedPortfolioYear} ]`}
                                        </UnoButton>


                                    </div>
                                </div>
                                :
                                null
                        }

                    </> : null
            }



        </div>
    );
}



